import { useCallback, type Dispatch, type SetStateAction } from 'react';
import type { ImplementationGuideDetail, OrganizationItemContextView } from './types';

export function useGuideContextUpdater(
  setGuide: Dispatch<SetStateAction<ImplementationGuideDetail | null>>,
) {
  return useCallback(
    (taskId: string, context: OrganizationItemContextView) => {
      setGuide((prev) => {
        if (!prev) return prev;
        return {
          ...prev,
          phases: prev.phases.map((phase) => ({
            ...phase,
            tasks: phase.tasks.map((t) =>
              t.id === taskId ? { ...t, organizationContext: context } : t,
            ),
          })),
        };
      });
    },
    [setGuide],
  );
}
